import React from "react";
import "./started.scss";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
const Started = () => {
  const nav = useNavigate();
  return (
    <div>
      <div className="started">
        <div className="left">
          <div className="top">
            <h1>MADIS-AI</h1>
          </div>
          <div className="bottom">
            <h1>
              Streamline your workflows and save time with our efficient chat
              bot. From answering frequently asked questions to automating
              repetitive tasks, it's your virtual assistant ready to enhance
              productivity.
            </h1>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <h3>Get Started</h3>
            <div className="two">
              <Link to="/login">
                <button>Log in</button>
              </Link>
              <Link to="/signup">
                <button>Sign up</button>
              </Link>
            </div>
          </div>
          <div className="bottom">
            <div className="logo">
              <h5>MADIS</h5>
            </div>
            <div className="terms mt-3">
              <p>Terms of use</p>
              <p>Privacy policy</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Started;
